/**
 * Portail d'entrée Maisons Bocuse. Hero éditorial (signature rouge sur marine,
 * charte en place) + 3 tuiles vers les rubriques. Aucun catalogue ici : les
 * maisons descendent derrière la tuile "Nos maisons".
 */
import { Link } from '../lib/router';
import { useBranding } from '@alterrego/module-branding';
import { useI18n } from '../i18n';
import { LangSwitcher } from '../components/LangSwitcher';
import './HomeScreen.css';

const TILES = [
  { to: '/maisons', labelKey: 'tile_maisons', subKey: 'tile_maisons_sub', variant: 'maisons' },
  { to: '/carte-cadeau', labelKey: 'tile_giftcard', subKey: 'tile_giftcard_sub', variant: 'giftcard' },
  { to: '/univers', labelKey: 'tile_universe', subKey: 'tile_universe_sub', variant: 'universe' },
] as const;

export function HomeScreen() {
  const { t } = useI18n();
  const { branding } = useBranding();
  return (
    <div className="mb-portal">
      <header className="mb-portal-hero">
        <LangSwitcher />
        <p className="mb-portal-overline">{t('hero_overline')}</p>
        <h1 className="mb-portal-signature">{branding.shortName}</h1>
        <p className="mb-portal-subtitle">{t('hero_subtitle')}</p>
      </header>

      <nav className="mb-portal-tiles" aria-label={t('maisons_title')}>
        {TILES.map((tile) => (
          <Link key={tile.to} to={tile.to} className={`mb-tile mb-tile--${tile.variant}`}>
            <span className="mb-tile-bg" aria-hidden="true" />
            <span className="mb-tile-overlay" aria-hidden="true" />
            <span className="mb-tile-content">
              <span className="mb-tile-sub">{t(tile.subKey)}</span>
              <span className="mb-tile-label">{t(tile.labelKey)}</span>
            </span>
          </Link>
        ))}
      </nav>
    </div>
  );
}
